<template>
  <div>
    <el-table
      style="width: 100%"
      :data="tableData"
      row-key="platform"
      :expand-row-keys="expand_rows"
    >
      <el-table-column type="expand">
        <template slot-scope="{row}">
          <div v-if="row.configs.length > 0" style="display: flex; padding: 0 10px; flex-flow: column;">
            <span style="padding-bottom: 5px">多单开关：{{ row.configs[0].pos_long ? 'On' : 'Off' }}</span>
            <span style="padding-bottom: 5px">空单开关：{{ row.configs[0].pos_short ? 'On' : 'Off' }}</span>
            <span style="padding-bottom: 5px">波动幅度：{{ row.configs[0].wave_rate_min }}% - {{ row.configs[0].wave_rate_max }}%</span>
            <span style="padding-bottom: 5px">下单倍数：{{ row.configs[0].order_lever }}倍</span>
            <span style="padding-bottom: 5px">下单金额：{{ row.configs[0].order_amount }}U</span>
            <span style="padding-bottom: 5px">止盈点数：{{ row.configs[0].profit_percentage }}%(<span style="color: #07bd54">{{computIncome(row.configs[0])}}</span>)</span>
            <span style="padding-bottom: 5px">止损点数：{{ row.configs[0].loss_percentage }}%(<span style="color: #f56c6c">{{computLoss(row.configs[0])}}</span>)</span>
          </div>
          <div v-else style="display: flex; padding: 0 10px; flex-flow: column;">
            <span style="padding-bottom: 5px">多空开关：-</span>
            <span style="padding-bottom: 5px">多空开关：-</span>
            <span style="padding-bottom: 5px">波动幅度：-</span>
            <span style="padding-bottom: 5px">下单倍数：-</span>
            <span style="padding-bottom: 5px">下单金额：-</span>
            <span style="padding-bottom: 5px">止盈点数：-</span>
            <span style="padding-bottom: 5px">止损点数：-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="平台" prop="platform">
        <template slot-scope="props">
          <div style="display: flex; align-items: center">
            <div style="margin-left: -10px;">
              <img style="margin-right: 2px" width="12px" height="12px" :src="platformIcon(props.row.platform)">
            </div>
            <div>
              {{props.row.platform}}<span v-if="props.row.configs && props.row.configs.length> 0"> ({{props.row.configs[0].wave_rate_min }} - {{ props.row.configs[0].wave_rate_max }}%)<span style="color: red; font-size: 20px">•</span></span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" min-width="35">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" circle @click="editConfig(row.platform, row)">
            <i class="el-icon-edit-outline"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 配置保存对话框 -->
    <kline-wave-config-save ref="configForm" @successfn="getConfigList"></kline-wave-config-save>
  </div>
</template>

<script>
import api from '@/api/api'
import { getPlatformIcon } from '@/utils/platformIcon'
import KlineWaveConfigSave from '@/components/klineWaveConfigs/KlineWaveConfigSave.vue'

export default {
  name: 'KlineWaveConfigs',
  components: {
    KlineWaveConfigSave
  },
  data () {
    return {
      tableData: [],
      selectedPlatform: '',
      expand_rows: []
    }
  },
  created () {
    this.getConfigList()
  },
  methods: {
    computIncome (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.profit_percentage)) {
        return `${item.order_lever * item.order_amount * item.profit_percentage * 0.01}`
      }
      return ''
    },
    computLoss (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.loss_percentage)) {
        if (parseFloat(item.order_lever) * parseFloat(item.loss_percentage) >= 100) {
          return '已超爆仓阈值！'
        }
        return `${item.order_lever * item.order_amount * item.loss_percentage * 0.01}`
      }
      return ''
    },
    platformIcon (platform) {
      return getPlatformIcon(platform)
    },

    // 获取配置列表
    getConfigList () {
      this.$loading({ body: true })
      api.klineWaveConfigsList({}).then(res => {
        if (res.code === 0) {
          this.tableData = res?.data || []
        } else {
          this.$message.error({
            message: '获取配置失败',
            customClass: 'phone-custom-message'
          })
        }
      }).catch(res => {
        this.$message.error({
          message: '获取配置失败',
          customClass: 'phone-custom-message'
        })
      }).finally(_ => {
        this.$loading({}).close()
      })
    },

    // 编辑配置
    editConfig (platform, row) {
      const configForm = this.$refs.configForm
      if (row.configs && row.configs.length > 0) {
        configForm.show(row.configs[0], platform)
      } else {
        configForm.show(null, platform)
      }
    }
  }
}
</script>

<style scoped>

</style>
